(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FiltersBagsController', FiltersBagsController);

    FiltersBagsController.$inject = ['$uibModalInstance', '$translate', '$localStorage', 'toastr', 'filters', 'options',
        'list', 'StoreService', 'flyersConstants', 'moment'];

    function FiltersBagsController($uibModalInstance, $translate, $localStorage, toastr, filters, options, list,
                                   StoreService, flyersConstants, moment) {

        var vm = this;
        const DATE_FORMAT = $translate.instant('momentDateFormat');
        vm.originalFilters = angular.copy(filters);
        vm.filters = angular.copy(filters);
        vm.listFilter = list;
        vm.isImmoContext = $localStorage.defaultStore.immoContext;

        vm.colors = formatOptionsDict(options.colors);
        vm.sizes = formatOptionsDict(options.sizes);
        vm.categories = formatOptionsDict(options.categories);
        vm.brands = formatOptionsDict(options.brands);
        vm.tags = formatOptionsDict(options.tags);
        vm.customers = formatOptionsDict(options.customers);
        vm.users = formatOptionsDict(options.users);
        vm.configurations = formatOptionsDict(options.configurations);
        vm.hasInventory = filters.hasInventory;
        vm.viewByCategories = options.viewByCategories;

        vm.bedrooms = flyersConstants.SELECT_OPTIONS.IMMO.SELECT_FIVE;
        vm.parkingSpots = flyersConstants.SELECT_OPTIONS.IMMO.SELECT_FIVE;
        vm.bathrooms = flyersConstants.SELECT_OPTIONS.IMMO.SELECT_FIVE;

        StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
            vm.storeCategory = response.data.categoryKey;
        });
        vm.genders = formatOptionsDict(flyersConstants.SELECT_OPTIONS.RETAIL.GENDERS);

        vm.itemsPerPageOptions = options.itemsPerPageOptions;
        vm.sortOptions = options.sortOptions;
        vm.numPerPage = options.numPerPage;
        vm.selectedSort = options.selectedSort;

        vm.closeModal = function(response, applyFilters) {
            if (!applyFilters) {
                vm.filters = vm.originalFilters;
            }
            $uibModalInstance.close(response);
        }

        vm.closeDropDown = function () {
            $("md-backdrop").trigger('click');
        }

        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey);
        };

        vm.onChangeItemsPerPage = function (newValue) {
            vm.numPerPage = newValue;
        };

        vm.onSelectedSortOption = function (newValue) {
            vm.selectedSort = newValue;
        };

        vm.getSelectedText = function (filter) {
            if (filter.length === 0) return '';

            var elementTranslate = (filter[0].label);
            if (elementTranslate.includes("."))
                elementTranslate = $translate.instant(filter[0].label);

            if (filter.length === 1) {
                return '<span class="highlight">' + elementTranslate + '</span>';
            }

            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' ' + $translate.instant('flyers.filters.selected');

                return '<span class="highlight">' + elementTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';
        }

        vm.clearFilters = function () {
            vm.filters = {
                // Common
                customers: [],
                users: [],
                brands: [],
                configurations: [],
                tags: [],
                hasInventory : !vm.isImmoContext,
                sortSelected: {
                    value: 'lastModifiedDate',
                    direction: 'desc',
                },
                bagSinceDate: null,
                bagUntilDate: null,

                // Retail
                categories: [],
                colors: [],
                sizes: [],
                genders: [],

                // Immo
                region: [],
                bedrooms: [],
                bathrooms: [],
                parkingSpots: [],
                minValue: null,
                maxValue: null,
                minMeters: null,
                maxMeters: null,
                sinceDate: null,
                untilDate: null,
            };
        }

        vm.applyFilters = function () {
            var filters = angular.copy(vm.filters);
            filters.customers = filters.customers.map(function(customer) { return customer.id });
            filters.users = filters.users.map(function(user) { return user.id });
            filters.brands = filters.brands.map(function(brand){ return brand.name });
            filters.configurations = (filters.configurations || []).map(
                function (configuration) {
                    return configuration.code;
                }
            );
            filters.tags = (filters.tags || []).map(
                function (tag) {
                    return tag.label;
                }
            );

            filters.categories = filters.categories.map(function(category){ return category.key });
            filters.colors = filters.colors.map(function(color){ return color.label });
            filters.sizes = filters.sizes.map(function(size){ return size.label });
            filters.genders = filters.genders.map(function(gender){ return gender.id });

            filters.region = (filters.region || []).map(function (region) { return region.address; });
            filters.bedrooms = (filters.bedrooms || []).map(function (bedroom) { return bedroom.value; });
            filters.bathrooms = (filters.bathrooms || []).map(function (bathroom) { return bathroom.value; });
            filters.parkingSpots = (filters.parkingSpots || []).map(function (parking) { return parking.value; });
            filters.sortDirection = filters.sortSelected
                ? filters.sortSelected.direction
                : "desc";
            filters.sortBy = filters.sortSelected
                ? filters.sortSelected.value
                : "lastModifiedDate";

            var totalFilters =
                // Common
                (angular.isArray(vm.filters.customers) ? vm.filters.customers.length : 0) +
                (angular.isArray(vm.filters.users) ? vm.filters.users.length : 0) +
                (angular.isArray(vm.filters.brands) ? vm.filters.brands.length : 0) +
                (angular.isArray(vm.filters.configurations) ? vm.filters.configurations.length : 0) +
                (angular.isArray(vm.filters.tags) ? vm.filters.tags.length : 0) +
                (vm.filters.bagSinceDate && vm.filters.bagUntilDate ? 1 : 0) +

                // Retail
                (angular.isArray(vm.filters.categories) ? vm.filters.categories.length : 0) +
                (angular.isArray(vm.filters.colors) ? vm.filters.colors.length : 0) +
                (angular.isArray(vm.filters.sizes) ? vm.filters.sizes.length : 0) +
                (angular.isArray(vm.filters.genders) ? vm.filters.genders.length : 0) +

                // Immo
                (angular.isArray(vm.filters.region) ? vm.filters.region.length : 0) +
                (angular.isArray(vm.filters.bedrooms) ? vm.filters.bedrooms.length : 0) +
                (angular.isArray(vm.filters.bathrooms) ? vm.filters.bathrooms.length : 0) +
                (angular.isArray(vm.filters.parkingSpots) ? vm.filters.parkingSpots.length : 0) +
                (vm.filters.minValue && vm.filters.maxValue ? 1 : 0) +
                (vm.filters.minMeters && vm.filters.maxMeters ? 1 : 0) +
                (vm.filters.sinceDate && vm.filters.untilDate ? 1 : 0);

            if ((filters.customers).length > 0) {
                vm.listFilter.customers = filters.customers;
            } else {
                vm.listFilter.customers = [];
            }

            if (filters.users && filters.users.length > 0) {
                vm.listFilter.users = filters.users;
            } else {
                vm.listFilter.users = [];
            }

            if ((filters.brands).length > 0) {
                vm.listFilter.brands = filters.brands;
            } else {
                vm.listFilter.brands = [];
            }

            if (filters.configurations.length > 0) {
                if (filters.configurations.includes('basic')) {
                    vm.listFilter.isBasic = true;
                } else {
                    delete vm.listFilter.isBasic;
                }
                if (filters.configurations.includes('launch')) {
                    vm.listFilter.isLaunch = true;
                } else {
                    delete vm.listFilter.isLaunch;
                }
                if (filters.configurations.includes('delivered')) {
                    vm.listFilter.isDelivered = true;
                } else {
                    delete vm.listFilter.isDelivered;
                }
            } else {
                delete vm.listFilter.isBasic;
                delete vm.listFilter.isLaunch;
                delete vm.listFilter.isDelivered;
            }

            if (filters.tags.length > 0) {
                vm.listFilter.tags = filters.tags;
            } else {
                vm.listFilter.tags = [];
            }

            if (angular.isString(filters.bagSinceDate) && filters.bagSinceDate.length > 0) {
                vm.listFilter.startDate = moment(
                    filters.bagSinceDate,
                    DATE_FORMAT
                ).toDate();
            } else {
                delete vm.listFilter.startDate;
            }

            if (angular.isString(filters.bagUntilDate) && filters.bagUntilDate.length > 0) {
                vm.listFilter.endDate = moment(
                    filters.bagUntilDate,
                    DATE_FORMAT
                ).toDate();
            } else {
                delete vm.listFilter.endDate;
            }

            if ((filters.categories).length > 0) {
                vm.listFilter.categoryKeys = filters.categories;
                vm.listFilter.categoryKey = filters.categories[0];
            } else {
                vm.listFilter.categoryKeys = [];
            }

            if ((filters.colors).length > 0) {
                vm.listFilter.colors = filters.colors;
            } else {
                vm.listFilter.colors = [];
            }

            if ((filters.sizes).length > 0) {
                vm.listFilter.sizes = filters.sizes;
            } else {
                vm.listFilter.sizes = [];
            }

            if ((filters.genders).length > 0) {
                vm.listFilter.genders = filters.genders;
            } else {
                vm.listFilter.genders = [];
            }

            if ((filters.region).length > 0) {
                vm.listFilter.region = filters.region;
            } else {
                vm.listFilter.region = [];
            }

            if ((filters.bedrooms).length > 0) {
                vm.listFilter.bedrooms = filters.bedrooms;
            } else {
                vm.listFilter.bedrooms = [];
            }

            if ((filters.bathrooms).length > 0) {
                vm.listFilter.bathrooms = filters.bathrooms;
            } else {
                vm.listFilter.bathrooms = [];
            }

            if ((filters.parkingSpots).length > 0) {
                vm.listFilter.parkingSpots = filters.parkingSpots;
            } else {
                vm.listFilter.parkingSpots = [];
            }

            if (filters.minValue && filters.maxValue) {
                vm.listFilter.minValue = filters.minValue;
                vm.listFilter.maxValue = filters.maxValue;
            } else {
                delete vm.listFilter.minValue;
                delete vm.listFilter.maxValue;
            }

            if (filters.minMeters && filters.maxMeters) {
                vm.listFilter.minMeters = filters.minMeters;
                vm.listFilter.maxMeters = filters.maxMeters;
            } else {
                delete vm.listFilter.minMeters;
                delete vm.listFilter.maxMeters;
            }

            if (angular.isString(filters.sinceDate) && filters.sinceDate.length > 0) {
                vm.listFilter.sinceDate = moment(
                    filters.sinceDate,
                    DATE_FORMAT
                ).toDate();
            } else {
                delete vm.listFilter.sinceDate;
            }
            if (angular.isString(filters.untilDate) && filters.untilDate.length > 0) {
                vm.listFilter.untilDate = moment(
                    filters.untilDate,
                    DATE_FORMAT
                ).toDate();
            } else {
                delete vm.listFilter.untilDate;
            }

            vm.closeModal(
                {
                    filtered: filters,
                    selectedFilters: angular.copy(vm.filters),
                    totalFilters: totalFilters,
                    listFilter: vm.listFilter,
                    changeView: vm.changeView,
                    sortSelected: vm.selectedSort,
                    numPerPage: vm.numPerPage
                },
                true);
        }

        function formatOptionsDict(optionsDict) {
            if (!optionsDict) {
                return []
            }
            var count = 0;
            optionsDict.forEach(function(option) {
                if (typeof option === 'string' || option instanceof String) {
                    optionsDict[count] = {'label': option};
                } else if (!option.hasOwnProperty('label')){
                    if (option.hasOwnProperty('title')) {
                        option.label = option.title;
                    } else if (option.hasOwnProperty('fullName')) {
                        option.label = option.fullName;
                    } else {
                        option.label = option.name;
                    }
                }
                count++;
            });

            count = 1;
            optionsDict.forEach(function(option) {
                if(!option.hasOwnProperty('id')){
                    option.id = count;
                }
                count++;
            });
            return optionsDict;
        }
    }

})();
